import { FormItem } from 'components';
import usePrevious from 'hooks/usePrevious';
import React, { memo, useLayoutEffect, useRef, useState } from 'react';

export interface SingleOTPInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean;
}

export function SingleOTPInputComponent(props: SingleOTPInputProps) {
  const { focus, autoFocus, ...rest } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);
  const [touch, setTouch] = useState(false);
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return (
    <FormItem validateStatus={!rest.value && touch ? 'error' : ''}>
      <input ref={inputRef} {...rest} onBlur={() => setTouch(true)} />
    </FormItem>
  );
}

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
